// Concept P: share bar ([data-share], template-parts/share.php). The network buttons are plain links (no third-party
// script, nothing is loaded before a click). This module only adds "Link kopieren" (clipboard + toast) and the native
// Web Share button (navigator.share – covers Instagram and other apps on mobile), which stays hidden when unsupported.
import { on, qsa, t } from './dom.js';
import { toast } from './toast.js';
import { ktPrompt } from './modal.js';
import { track, config } from './track.js';

/** 1.9.8 tracking: GA4 share (method = network | native | copy, item = the event/product of the page's view_item). */
function shared(box, method) {
  const view = ((config() || {}).ev || []).find((x) => x.n === 'view_item');
  const item = view && view.p.items && view.p.items[0];
  track('share', { method, content_type: item ? (item.item_id[0] === 'P' ? 'product' : 'event') : 'page', item_id: item ? item.item_id : location.pathname });
}

function payload(box) {
  return { url: box.dataset.shareUrl || window.location.href.split(/[?#]/)[0], title: box.dataset.shareTitle || document.title, text: box.dataset.shareText || '' };
}

export function initShare() {
  const boxes = qsa('[data-share]');
  if (!boxes.length) return;
  if (typeof navigator.share === 'function') {
    boxes.forEach((box) => {
      const btn = box.querySelector('[data-share-native]');
      const p = payload(box);
      if (btn && (!navigator.canShare || navigator.canShare({ url: p.url }))) btn.hidden = false;
    });
  }
  // analytics (1.9.0): share channel (plain network links are tracked here, the tracker skips them as "outbound")
  on(document, 'click', '[data-share-link]', (e, a) => { window.ktTrack?.('share', a.dataset.shareLink); shared(a.closest('[data-share]'), a.dataset.shareLink); });
  on(document, 'click', '[data-share-native]', async (e, btn) => {
    const box = btn.closest('[data-share]');
    if (!box) return;
    window.ktTrack?.('share', 'native');
    shared(box, 'native');
    const p = payload(box);
    try {
      await navigator.share({ title: p.title, text: p.text ? p.title + ' – ' + p.text : p.title, url: p.url });
    } catch (err) { /* cancelled by the user */ }
  });
  on(document, 'click', '[data-share-copy]', async (e, btn) => {
    const box = btn.closest('[data-share]');
    if (!box) return;
    const { url } = payload(box);
    window.ktTrack?.('share', 'copy');
    shared(box, 'copy');
    try {
      await navigator.clipboard.writeText(url);
      toast('success', t('share.copied'));
    } catch (err) {
      ktPrompt({ title: t('share.copy'), label: 'URL', value: url, readonly: true, select: true, cancel: false });
    }
  });
}
